<style scoped lang="scss">
    .p {
        background: #F5F5F5;
        border: 1px solid #E8E8E8;
        border-radius: 4px;
    }
</style>

<template>
    <div>
        <v-title title="资料缺失（请根据提示补充资料后重新提交）" style="margin-left: -15px"></v-title>
        <div class="p color_red fs14 pl15 pr15 pt5 pb5">
            <p v-for="(data,index) in list" :key="index">{{data.perfectContent}}</p>
        </div>
    </div>
</template>

<script>
  import VTitle from "../common/v-title";

  export default {
    name: "referral-missing-form",
    components: {VTitle},
    props: {
      value: {
        type: Number,
        default: 0
      },
      list: Array
    },
    data() {
      return {
        form: {}
      }
    },
  }
</script>


